// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"39edb375","630":"a85fbf9f"}[chunkId] + ".chunk.js";
};